export enum PublisherDealType {
    'Guaranteed' = 2,
    'UnreservedFixed' = 4,
    'PrivateAuction' = 5
}
